module.exports = __webpack_public_path__ + "img/canvasMenuCopy.670007ca.svg";